import { Collection } from '../../types/database.type';
import { UnitCode } from './unitCode';

export interface UnitLocation {
  street?: string;
  blockNumber?: string;
  staircaseNumber?: string | null;
  floor?: string;
  number: string;
}

export enum RentalUnitType {
  APARTMENT = 'apartment',
  PARKING = 'parking',
  STORAGE = 'storage'
}

export interface RentalUnit extends UnitLocation {
  id: string;
  estateId: string;
  /** Only explicit false means that legal ownership has not been transferred yet. */
  legalOwnership?: boolean | null;
  /** Legal ownership transfer date as a Unix timestamp in milliseconds; absent when unknown. */
  legalOwnershipDate?: number | null;
  shareInEstate?: number;

  unitCodes: UnitCode;
  lastOwnerChange?: number;

  /** @deprecated as fukk */
  customFields?: Collection<string>[] | null;
}

export namespace RentalUnit {
  /**
   * Checks whether a unit has legal ownership under the backward-compatible rules.
   * @param {Pick<RentalUnit, 'legalOwnership'>} unit Unit to inspect
   * @return {boolean} True unless the flag is explicitly false
   */
  export function hasLegalOwnership(unit: Pick<RentalUnit, 'legalOwnership'>): boolean {
    return unit.legalOwnership !== false;
  }
}

export interface RentalUnitWithType extends RentalUnit {
  unitType: RentalUnitType;
}

export type UnitLike = Partial<Record<'number' | 'staircaseNumber' | 'floor' | 'blockNumber' | 'street', string | null>>;
